// Per-program content tables used by the ChallengesSection feature card.
// Each row references an i18n key so the data is locale-aware while
// still owning the icon mapping (icons stay locale-independent).
//
// The shape is preserved — { Icon, key } / { valueKey, labelKey } /
// `keys` — and the ChallengesSection component resolves the strings
// with `t()` at render time.

import {
  Rocket, Target, Moon, Percent,
  ListChecks, GitMerge, Tag, Infinity as InfinityIcon,
} from "lucide-react";

export const PROGRAM_BULLETS = {
  instant: [
    { Icon: Rocket,       key: "builder.programs.instant.bullets.0" },
    { Icon: Target,       key: "builder.programs.instant.bullets.1" },
    { Icon: Moon,         key: "builder.programs.instant.bullets.2" },
    { Icon: Percent,      key: "builder.programs.instant.bullets.3" },
  ],
  oneStep: [
    { Icon: ListChecks,   key: "builder.programs.oneStep.bullets.0" },
    { Icon: Target,       key: "builder.programs.oneStep.bullets.1" },
    { Icon: InfinityIcon, key: "builder.programs.oneStep.bullets.2" },
    { Icon: Percent,      key: "builder.programs.oneStep.bullets.3" },
  ],
  twoStep: [
    { Icon: Tag,          key: "builder.programs.twoStep.bullets.0" },
    { Icon: GitMerge,     key: "builder.programs.twoStep.bullets.1" },
    { Icon: InfinityIcon, key: "builder.programs.twoStep.bullets.2" },
    { Icon: Percent,      key: "builder.programs.twoStep.bullets.3" },
  ],
};

export const PROGRAM_STATS = {
  instant: [
    { value: "$5K – $100K", labelKey: "builder.programs.instant.stats.0" },
    { valueKey: "builder.programs.instant.stats.1v", labelKey: "builder.programs.instant.stats.1" },
    { value: "8%",          labelKey: "builder.programs.instant.stats.2" },
    { valueKey: "builder.programs.instant.stats.3v", labelKey: "builder.programs.instant.stats.3" },
  ],
  oneStep: [
    { value: "$10K – $100K", labelKey: "builder.programs.oneStep.stats.0" },
    { value: "10%",          labelKey: "builder.programs.oneStep.stats.1" },
    { value: "6%",           labelKey: "builder.programs.oneStep.stats.2" },
    { valueKey: "builder.programs.oneStep.stats.3v", labelKey: "builder.programs.oneStep.stats.3" },
  ],
  twoStep: [
    { value: "$10K – $250K", labelKey: "builder.programs.twoStep.stats.0" },
    { value: "8% → 5%",      labelKey: "builder.programs.twoStep.stats.1" },
    { value: "7%",           labelKey: "builder.programs.twoStep.stats.2" },
    { valueKey: "builder.programs.twoStep.stats.3v", labelKey: "builder.programs.twoStep.stats.3" },
  ],
};

export const PROGRAM_PERKS = {
  instant: ["builder.programs.instant.perks.0", "builder.programs.instant.perks.1", "builder.programs.instant.perks.2", "builder.programs.instant.perks.3"],
  oneStep: ["builder.programs.oneStep.perks.0", "builder.programs.oneStep.perks.1", "builder.programs.oneStep.perks.2", "builder.programs.oneStep.perks.3"],
  twoStep: ["builder.programs.twoStep.perks.0", "builder.programs.twoStep.perks.1", "builder.programs.twoStep.perks.2", "builder.programs.twoStep.perks.3"],
};
